import type { ApolloClient, NormalizedCacheObject } from '@apollo/client';
import { ApolloProvider } from '@apollo/client';
import { App } from '@application/components';
import type { AuthState } from '@application/state';
import { authState } from '@application/state';
import type { Request } from 'express';
import type { FC, ProviderProps } from 'react';
import { HelmetProvider } from 'react-helmet-async';
import { I18nextProvider } from 'react-i18next';
import { StaticRouter } from 'react-router-dom/server';
import { RecoilRoot } from 'recoil';
import { StaticProvider } from './staticContext';
import type { StaticRouterContext } from './staticContext';

export interface ServerAppProps {
  serverRequest: Request;
  client: ApolloClient<NormalizedCacheObject>;
  initialAuthState: AuthState;
  context: StaticRouterContext;
  helmetContext: ProviderProps;
}

export const ServerApp: FC<ServerAppProps> = (props) => {
  const { serverRequest, client, initialAuthState, context, helmetContext } = props;
  const { originalUrl, i18n } = serverRequest;

  return (
    <HelmetProvider context={helmetContext}>
      <ApolloProvider client={client}>
        <StaticRouter location={originalUrl}>
          <StaticProvider value={context}>
            <I18nextProvider i18n={i18n}>
              <RecoilRoot
                initializeState={({ set }) => {
                  set(authState, initialAuthState);
                }}
              >
                <App />
              </RecoilRoot>
            </I18nextProvider>
          </StaticProvider>
        </StaticRouter>
      </ApolloProvider>
    </HelmetProvider>
  );
};
